import $ = require('jquery');
import DragHelper = require('diy/common/js/dd/DragHelper');

/**
 * @depends diy.tooltip.js
 */
    class ModuleHelper extends DragHelper {
        protected restrictedTooltipOptions = {
        };
        // How much room to leave at the top before flipping the tooltip
        private tooltipFlipThresh = 50;
        setError(error: string) {
            if (error === null) {
                if (this.element.is(':diy-tooltip')) {
                    this.element.diy_tooltip('hide');
                }
                return;
            }
            if (!this.element.is(":diy-tooltip")) {
                this.element.diy_tooltip($.extend({
                   cls: 'restrictedAreaTooltip diy-alert-tooltip',
                   triggerMode: 'none',
                   fadeInDelay: 300,
                   fadeOutDelay: 100,
                   appendTo: this.element
                }, this.restrictedTooltipOptions));
            }
            this.element.diy_tooltip('option', 'content', error);
            this.element.diy_tooltip('option', 'anchor', 'top');
            this.element.diy_tooltip('show');

            let flip = this.element.diy_tooltip('widget').offset().top < this.tooltipFlipThresh;
            this.element.diy_tooltip('option', 'anchor', flip ? 'bottom' : 'top');
        }
    }

export = ModuleHelper;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/ModuleHelper.ts
 **/